import React from 'react';
import { injectIntl } from 'react-intl';
import { object } from 'prop-types';

import { schoolLogoLabel } from '../../util/schoolLogoLabel';

const LogoLink = ({ intl }) => (
  <a
    className="logo-lg"
    target="_blank"
    rel="noopener noreferrer"
    title={schoolLogoLabel(intl)}
    style={{ maxWidth: '100%' }}
  >
    <img
      src="/assets/images/sign-in-logo.png"
      alt={schoolLogoLabel(intl)}
      title={schoolLogoLabel(intl)}
      style={{ maxWidth: '100%' }}
    />
  </a>
);

LogoLink.propTypes = {
  intl: object,
};

export default injectIntl(LogoLink);
